import { Tag } from '@cian/components';
import * as React from 'react';

import { IGeoDeveloperTag } from '../../../../state/tags/definitions/geo/developer';
import { TagNew } from '../../TagNew';

import { tagThemeSmall } from '../../tag_theme';

export interface IGeoBuilderTagItemProps {
  tag: IGeoDeveloperTag;
  withNewTag?: boolean;
  onDeleteClick(): void;
}

export const GeoBuilderTagItem = (props: IGeoBuilderTagItemProps) => {
  const TagComponent = React.useMemo(() => (props.withNewTag ? TagNew : Tag), [props.withNewTag]);

  return (
    <TagComponent onDeleteClick={props.onDeleteClick} tagStyles={tagThemeSmall}>
      {props.tag.text}
    </TagComponent>
  );
};
